import { FAVORITE_DELIVERY_TYPE, FAVORITE_DELIVERY_TYPE_COOKIE } from 'common/constants';
import { TFunction } from 'i18next';

type FavoriteAddressHintVariant = 'REGION' | 'DELIVERY_OR_PICKUP';

const HINT_CONTENT: Record<FavoriteAddressHintVariant, string> = {
  REGION: 'header.main.favorite-address.hint.region.content',
  DELIVERY_OR_PICKUP: 'header.main.favorite-address.hint.delivery.content',
};

export const getFavoriteAddressHintVariant = (
  cookies: Record<string, string>,
): FavoriteAddressHintVariant => {
  const favoriteDeliveryType = cookies[FAVORITE_DELIVERY_TYPE_COOKIE];

  if (favoriteDeliveryType === FAVORITE_DELIVERY_TYPE.REGION) {
    return 'REGION';
  }

  return 'DELIVERY_OR_PICKUP';
};

type FavoriteAddressHintDisplay = {
  title: string;
  paragraph: string;
  primaryButtonText: string;
  secondaryButtonText: string | null;
};

export const getFavoriteAddressHintDisplay = (
  cookies: Record<string, string>,
  t: TFunction,
): FavoriteAddressHintDisplay => {
  const variant = getFavoriteAddressHintVariant(cookies);

  return {
    title: t('header.main.favorite-address.hint.title'),
    paragraph: t(HINT_CONTENT[variant]),
    primaryButtonText:
      variant === 'REGION'
        ? t('header.main.favorite-address.hint.region.choose')
        : t('header.main.favorite-address.hint.delivery.agree'),
    secondaryButtonText:
      variant === 'REGION' ? null : t('header.main.favorite-address.hint.delivery.change'),
  };
};
